import { Api } from "./config/request";

export const getFeed = () => Api.getSearchRequest('home/v1/home-content/');

export const callSessionSet = payload => Api.postRequest('misc/v1/session/', payload);


export const Home = {
  getFeed, callSessionSet
}